import React, { useState, useEffect } from "react";

import delivery from "../assets/images/deliveryBike.png";
import pickup from "../assets/images/pickUp.png";
import category from "../assets/images/category.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import ApiService from "../services/ApiService";
import AuthService from "../services/AuthService";
import PickupTab from "../components/PickupTab";
import PageLoader from "../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getDeviceToken } from "../utils/helper";
import Header from "../components/Header";


const HomePage = () => {
 
  const [activeTab, setActiveTab] = useState(localStorage.getItem('type') || 'delivery');

  const [showPickupTab, setShowPickupTab] = useState(false);
  const navigate = useNavigate();
  const pathname = useLocation();
  const [isLoader, setIsLoader] = useState(false);
  const [promotionalBanners, setPromotionalBanners] = useState([]);
  const [categories, setCategories] = useState([]);
  const [promos, setPromos] = useState([]);

  const searchParams = new URLSearchParams(window.location.search);
  const tabParam = searchParams.get('tab') || activeTab;
  const change = searchParams.get('change') || false;

  const settings = {
      infinite: promotionalBanners.length > 1,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
    
    };
    

  useEffect(() => {
    window.scrollTo(0, 0);
    if (tabParam) {
      setActiveTab(tabParam);
    }
    // if (change) {
      setShowPickupTab(change);
    // }
  }, [pathname, tabParam, change]);



  const address = JSON.parse(localStorage.getItem("address"));
  const branch = JSON.parse(localStorage.getItem("branch"));
  const authUser = AuthService.getCurrentUser();


  const guestLogin = async () => {
    try {
      const token = getDeviceToken();
      const response = await ApiService.request({
        method: "POST",
        url: "/guestLogin",
        data: {deviceToken: token}
      });

      const data = response.data;
      
      if (data.status) {
        const token = data.data.auth_token;
        const user = data.data.user;
        user.auth_token=token;
        AuthService.setCurrentUser(user);
        return true;
      } else {
        toast.error(data.message || "Guest login failed");
        return false;
      }
    } catch (error) {
      console.error("Guest login error:", error);
      toast.error("Something went wrong during guest login");
      return false;
    }
  };


 useEffect(() => {
   const init = async () => {
    if (!authUser) {
      const loginSuccess = await guestLogin();
      console.log(loginSuccess);

      if (loginSuccess) {
        // After successful guest login, check if we need to redirect for address
        if(tabParam == "delivery" && !address){
          const searchParams = new URLSearchParams(window.location.search);
          const goto = searchParams.get('goto') || '';
          console.log("goto "+goto);
          const currentUser = AuthService.getCurrentUser();
          if(currentUser?.is_guest){
            navigate('/add-address' + (goto ? `?goto=${goto}` : ''));
          }else{
            navigate('/address-list' + (goto ? `?goto=${goto}` : ''));
          }
        } else {
          await getDashboard();
        }
      }
    } else {
      await getDashboard();
    }
   };

   init();
 }, []);


  const changeTab = async (tab) => {
    // if (authUser.is_guest) {
    //   toast.error('Please login or create new account to use this feature.');
    //    navigate('/login');
    //   return 0;
    // }
    setActiveTab(tab);
    localStorage.setItem('type',tab);

    console.log(branch);
    if (tab == "pickup" && !branch?._id) {
      navigate('?tab='+tab+"&change=true");
    }else{
      navigate('?tab='+tab);
    }
    
  }



  const getDashboard = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getDashboard",
        data: {
          device_type: 'website',
        },
      });

      const data = response.data;
      console.log(data);

      if (data.status) {
        setPromotionalBanners(data.data.banners); 
        setCategories(data.data.categories);
        setPromos(data.data.promos);
        console.log(data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Dashboard loading error:", error);
      toast.error("Failed to load dashboard");
    } finally {
      setIsLoader(false);
    }
  };



  return (
    <>
      {isLoader ?(
        <PageLoader />
        ):(
        <div className="header-banner bg-gradient" id="home">
          <div className="container">
            <div className="row">
              <div
                className="col-md-12 shadow main-heading"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                    {/* Top Bar */}
                    <Header title='Home' />


                      <div className="main-toggle d-flex justify-content-center align-items-center mb-3">
                        <div className="toggle-container">
                          <div
                            className={`toggle-btn ${
                              activeTab === "delivery" ? "active" : ""
                            }`}
                            onClick={() => changeTab("delivery")}
                          >
                            <img src={delivery} alt="Delivery" className="icon" />
                            <span>Delivery</span>
                          </div>
                          <div
                            className={`toggle-btn ${
                              (activeTab === "pickup" ) ? "active" : ""
                            }`}
                            onClick={() => changeTab("pickup")}
                          >
                            <img src={pickup} alt="Pickup" className="icon gray-icon" />
                            <span className="gray-text">Pick up</span>
                          </div>
                        </div>
                      </div>
                  {/* Delivery Tab */}


                  {activeTab=="pickup" && String(showPickupTab)=="true" ?(

                    <div className="tab h-100">
                      <PickupTab />
                    </div>

                  ) : (
                     <div className="tab">
                      <div className="main-header d-flex justify-content-center align-items-center">
                        <div className="slider-container mx-3">
                          <Slider {...settings}>
                            {promotionalBanners.map((banner) => (
                              <div className="slide" key={banner._id}>
                                <div className="content">
                                  <img
                                    src={banner.image}
                                    alt={banner.title}
                                    className="slide-image"
                                  />
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>

                        
                      </div>
                      {/* Categories */}
                      <div className="category mx-4 d-flex justify-content-between mt-4">
                        <div className="category-left d-flex align-items-center">
                          <p className="fw-semibold">Menu Categories</p>
                          <img src={category} alt="Category" className="category" />
                        </div>
                        <Link to="/items">
                          <div className="category-right d-flex align-items-center">
                            <p className="text-black">
                              View All
                              <FaArrowRight className="category-arrow-right mx-2" />
                            </p>
                          </div>
                        </Link>
                      </div>
                      {/* Categories */}
                      <div className="deals-container row align-items-center m-3">
                        {categories.map((category) => (
                          <div className="col-3 p-0 my-3 text-center">
                            <Link to={"items/"+category._id} >
                              <div className="data">
                                <img
                                  src={category.image}
                                  alt="Promotion"
                                  className="deal-slider"
                                />
                                <div className="text-container">
                                  <p className="fw-semibold">{category.title}</p>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}

                      </div>

                      {/* Special Offer */}
                      {promos.length > 0 && 
                        <div className="special-offer-heading mx-3 pb-4">
                          <p className="fw-semibold">Special Offers</p>
                          <div className="row">
                            {promos.map((promo) => (
                              <div className="col-md-2 col-6">
                                  <Link to={"/promo/"+promo._id} >
                                    <img src={promo.image} alt="" className="m-2 shadow" />
                                  </Link>
                              </div>
                              ))}
                          </div>
                        </div>
                      }

                    </div>

                  ) }


              </div>

              {/* Right Side */}
              {/* <div className="col-md-8 right-logo d-flex justify-content-center">
                <img src={logo} />
              </div> */}
            </div>
          </div>
        </div>
        )}

    </>
  );
};

export default HomePage;
